import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, rdata) {
  let filters = useDataValue({
    viewPath: props.viewPath,
    path: 'selected.filters',
    context: 'tab',
  })

  let location = useDataValue({
    context: 'global',
    path: 'current_location',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    if (!rdata) return rdata

    return {
      ...rdata,
      filters: {
        ...filters,
        filterData: {
          ...filters.filterData,
          locations: filters?.filterData?.locations ?? [
            { id: location._id, _id: location._id, name: location.name },
          ],
          stages: [],
          patients: [],
          assignees: [],
        },
      },
    }
  }, [location, filters, rdata])
}
